/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0",
    versionName: "0.4.0",
    versionChannel: "stable",
    buildDate: "2026-07-18T21:22:42.134Z",
    commitHash: "9f8c70a9a89e77708fb9e7e1a56818f05b76bfad",
};
